$(document).ready(function() {
    $('[data-nsi-source]').change(function (e){
        $('[data-nsi-destination="' + $(e.target).data('nsi-source') + '"]').val(
            JSON.stringify($(e.target).find('option[value="'+ $(e.target).val() +'"]').data('nsi'))
        );
    });

    var settingsJSON = function(txt) {
        var settings = txt;

        if (settings == '' || settings == null) {
            settings = '{}'
        };

        settings = JSON.parse(settings.replace(/\"=>/g, '":'));

        if (settings.attributes == undefined) {
            settings.attributes = [];
        }

        return settings;
    };

    $('#save_nsi_attribute').click(function (e){
        var formData = new FormData($(e.target).closest('form')[0]);
        var new_attribute = { name: formData.get('nsi_attribute[name]'), label: formData.get('nsi_attribute[label]'), kind: formData.get('nsi_attribute[kind]') };
        var settings = settingsJSON($('[data-nsi-attributes-target]').val());

        settings.attributes = settings.attributes.filter(function(attr) {
            return attr.name != this.name;
        }, new_attribute);

        settings.attributes.push(new_attribute);

        $('[data-nsi-attributes-target]').val(JSON.stringify(settings)).trigger('change');
    });

    $('[data-nsi-attributes-target]').change(function (e){
        var settings = settingsJSON($(e.target).val());
        $('.project-task-list .project-task-item').remove();

        settings.attributes.forEach(function(attr, idx) {
            if (attr.kind == null || attr.kind == undefined || attr.kind == undefined) {
                attr.kind = 'string'
            };
            attr_html = $('.project-task-item-template').html().replace(/\{name\}/g, attr.name).replace(/\{label\}/g, attr.label).replace(/\{kind\}/g, attr.kind);
            $('.project-task-list').append(attr_html);
        });
    });

    $(document).on('click', '.delete-nsi-attribute', function (e){
        var settings = settingsJSON($('[data-nsi-attributes-target]').val());
        attr_name = $(e.target).closest('.project-task-item').data('attribute-name');

        settings.attributes = settings.attributes.filter(function(attr) {
            return attr.name != this;
        }, attr_name);

        $('[data-nsi-attributes-target]').val(JSON.stringify(settings)).trigger('change');
    });

    $('[data-nsi-attributes-target]').trigger('change');
});
